'use strict';

var magnificPopup = require('../lib/magnific-popup.js');
var getParamByName = require('../lib/getParamByName.js');
var $ = window.jQuery;

var activeCardClass = 'imageGrid__item--active';

function ImageGrid() {
	var gridEl = document.getElementsByClassName('imageGrid-wrapper');
	if (!gridEl.length) {
		return;
	}
	
	/* ========================================================
	* 		Setup filter form
	========================================================= */
	var $filterEl = $('.galleryForm__select');
	var filterDefaults = [];
	for (var index = 0; index < $filterEl.length; index++) {
		var element = $filterEl[index];
		filterDefaults.push(element.children[0].value);
	}

	var selected = {};
	$filterEl.change(function() {
		if (filterDefaults.indexOf(this.value) !== -1) {
			selected[this.id] = undefined;
		} else {
			selected[this.id] = this.value;
		}

		var selectedClassesArr = ['.imageGrid__item--fake'];
		for (var index = 0; index < $filterEl.length; index++) {
			var element = $filterEl[index];
			if (selected[element.id] !== undefined) {
				selectedClassesArr.push('.' + selected[element.id]);
			}
		}
		var selectedClasses = selectedClassesArr.join(', ');

		$('.imageGrid__item').removeClass('imageGrid-category--hidden ' + activeCardClass);

		if (selectedClassesArr.length > 1) {
			$('.imageGrid__item:not(' + selectedClasses + ')').addClass('imageGrid-category--hidden');
		}
	});

	/* ========================================================
	* 	Setup lightbox for images (e.g. Inspiration Gallery)
	========================================================= */
	$('.imageGrid--images .imageGrid__item').magnificPopup({
		mainClass: 'mfp-imageGrid',
		type: 'image',
		gallery: {
			enabled: true,
			preload: [0, 2]
		}
	});

	/* ========================================================
	* 		Set filter based on query parameter
	 ========================================================= */
	var filterCategory = getParamByName('industry') || getParamByName('category');
	if (filterCategory) {
		// $('.imageGrid__item:not(.' + filterCategory + ', .imageGrid__item--fake)').addClass('imageGrid-category--hidden');
		var selectField = $('.galleryForm__select');
		selectField.val(filterCategory);
		selectField.change();
	}
}

module.exports = {
	init: ImageGrid
}

